import { httpCreate } from './http';

const http = httpCreate('/shop/api/order-statistics');

export const orderStatistics = {
	// 直播间-商城收益统计
	/**
	 * @param { Number } activityId 直播间id
	 */
	activitySalesStatistics(activityId) {
		return http.get(`/activity/${activityId}`);
	},
	// 直播间-商城销售排行榜
	/**
	 * @param { Number } activityId 直播间id
	 */
	activitySalesList(activityId) {
		return http.get(`/activity-list/${activityId}`);
	},
	// 用户-商城收益统计
	userSalesStatistics() {
		return http.get();
	},
	// 用户-商城销售排行榜
	userSalesList() {
		return http.get('/list');
	},
	// 用户-销售详情
	userSalesDetail(params) {
		return http.get('/re-purchase', { params });
	},
};
